import { render } from "./GhostDraftPreviewHolder.vue?vue&type=template&id=411a6618&ts=true"
import script from "./GhostDraftPreviewHolder.vue?vue&type=script&lang=ts"
export * from "./GhostDraftPreviewHolder.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/GhostDraftPreviewHolder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "411a6618"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('411a6618', __exports__)) {
    api.reload('411a6618', __exports__)
  }
  
  module.hot.accept("./GhostDraftPreviewHolder.vue?vue&type=template&id=411a6618&ts=true", () => {
    api.rerender('411a6618', render)
  })

}


export default __exports__